// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1SNdj","bigColWidth":"Table_bigColWidth__1Ez2H","biggerColWidth":"Table_biggerColWidth__yobqG","row":"Table_row__gTb-e","col":"Table_col__3nDP6"};